<template>
  <div class="discuss_wrap" v-loading="loading">
    <div class="menu-toggle" :class="{ 'menu-open': !menuFlag }" @click="toggleMenu"></div>
    <div class="discuss_left" v-if="menuFlag">
      <ul>
        <router-link tag="li"
         v-for="(item,index) in list" 
         :key="index" 
         :to="{path:item.path,query:{id:$route.query.id,classId:$route.query.classId,className:$route.query.className}}" 
         @click.native="reload()">
          <a class="list-group-item list-group-item-action">
            <i :class="item.class" :style="'background:url('+item.src+') no-repeat;background-size:100%'"/>
            <p>{{item.name}}</p>
          </a>
        </router-link>
      </ul>
    </div>
    <div class="discuss_right">
      <router-view></router-view>
    </div>  
  </div>
</template>

<script>
  export default {
    name: "discuss",
    inject: ['reload'],
    props:{
			isTurn:{ //是否是跳转过来的
				type: Boolean,
				default: true
			},
      CataId:'',//目录ID
      Cid:'',//classID
      Cname:'',//className
		},
    data(){
      return{
        menuFlag: true,
        loading: false,
        list:[]
      }
    },
    created(){
      console.log(this.$route.path,this.isTurn)
      if(this.$route.path=='/switch/discuss' || this.$route.path=='/learning_module'){
        if(this.isTurn){
           this.$router.push({
            path:'/switch/discuss/all',
            query:{
              id:this.$route.query.id,
              classId:this.$route.query.classId,
              className:this.$route.query.className,
            }
          })
        }else{
           this.$router.push({
            path:'/switch/discuss/all',
            query:{
              id:this.CataId,
              classId:this.Cid,
              className:this.Cname,
            }
          })
        }
      }
    },
    mounted(){
      $(".container-header").hide();
      console.log(this.$route.path)
      if(this.$route.path.split('/')[1]=='switch' || this.$route.path.split('/')[1]=='learning_module'){
        this.list = [
          {
            src:'../../../../../../static/images/study/icon/quanbutl_hv.png',
            name: '全部讨论区',
            path: '/switch/discuss/all',
            class: 'all'
          },
          {
            src:'../../../../../../static/images/study/icon/laoshiday_hv.png',
            name: '老师答疑区',
            path: '/switch/discuss/teacher',
            class: 'teacher'
          },
          {
            src:'../../../../../../static/images/study/icon/ketangjl_hv.png',
            name: '课堂交流区',
            path: '/switch/discuss/student',
            class: 'student'
          }
        ]
      }else{
        this.list = [
          {
            src:'../../../../../../static/images/study/icon/quanbutl_hv.png',
            name: '全部讨论区',
            path: '/dateCourse/discuss/all',
            class: 'all'
          },
          {
            src:'../../../../../../static/images/study/icon/laoshiday_hv.png',
            name: '老师答疑区',
            path: '/dateCourse/discuss/teacher',
            class: 'teacher'
          },
          {
            src:'../../../../../../static/images/study/icon/ketangjl_hv.png',
            name: '课堂交流区',
            path: '/dateCourse/discuss/student',
            class: 'student'
          }
        ]
      }
    },
    methods: {
      toggleMenu() {
        this.menuFlag = !this.menuFlag;
      },
    },
  }
</script>

<style lang="scss" scoped>
  .discuss_wrap{
    width: 100%;
    height: 100%;
    display: flex;
    background: #F4F4F4;
    .discuss_left{
      width:200px;
      height: calc(100% - 32px);
      background:rgba(232,242,255,1);
      border-radius:0px 4px 4px 0px;
      margin-top: 16px;
      ul{
        margin-top: 28px;
        li{
          width:200px;
          height:40px;
          text-align: center;
          a{
            height:40px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          i{
            display: block;
            width: 16px;
            height: 16px;
          }
          p{
            font-size:14px;
            font-weight:400;
            color:rgba(102,102,102,1);
            margin-left: 6px;
          }
        }
        .router-link-active{
          background: #fff;
          .all{
            background: url('../../../../../../static/images/study/icon/quanbutl.png') !important;
            background-size: 100% !important;
          }
          .teacher{
            background: url('../../../../../../static/images/study/icon/laoshidy.png') !important;
            background-size: 100% !important;
          }
          .student{
            background: url('../../../../../../static/images/study/icon/ketangjl.png') !important;
            background-size: 100% !important;
          }
          p{
            color: #5397F7;
          }
        }
      }
    }
    .discuss_right{
      flex: 1;
      margin: 16px;
      height: calc(100% - 32px);
      background: #fff;
    }
    .menu-toggle {
      position: absolute;
      top: 50%;
      left: 200px;
      width: 16px;
      height: 64px;
      margin-top: -32px;
      cursor: pointer;
      background: url("../../img/close.png");
      background-size: 100% 100%;
    }
    .menu-open {
      left: 0;
      background: url("../../img/close_right.png");
      background-size: 100% 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/discuss/discuss.vue